export class WebhookV1StandardPayloadSnapshotAccessDenied {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadSnapshotAccessDeniedTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadSnapshotAccessDeniedArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadSnapshotAccessDenied.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadSnapshotAccessDeniedTypeEnum;
(function (WebhookV1StandardPayloadSnapshotAccessDeniedTypeEnum) {
    WebhookV1StandardPayloadSnapshotAccessDeniedTypeEnum["SnapshotIncludesAccessDeniedItems"] = "SNAPSHOT_INCLUDES_ACCESS_DENIED_ITEMS";
})(WebhookV1StandardPayloadSnapshotAccessDeniedTypeEnum || (WebhookV1StandardPayloadSnapshotAccessDeniedTypeEnum = {}));
